"use strict";
/**
 * Play video on mouse hover, pause on mouse leave
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Alexandra Miro
 */
Object.defineProperty(exports, "__esModule", { value: true });
var videoHover = function () {
    var videoHoverEvent = function () {
        var videos = Array.from(document.querySelectorAll('.grid-product__secondary-video'));
        if (!videos)
            return;
        videos.forEach(function (video) {
            if (!video.classList.contains('loaded')) {
                video.addEventListener('mouseenter', function () {
                    var videoChild = video.querySelector('video');
                    videoChild === null || videoChild === void 0 ? void 0 : videoChild.play();
                    video.classList.add('loaded');
                });
                video.addEventListener('mouseleave', function () {
                    var videoChild = video.querySelector('video');
                    videoChild === null || videoChild === void 0 ? void 0 : videoChild.pause();
                });
            }
        });
    };
    window.addEventListener('scroll', videoHoverEvent, false);
    window.addEventListener('load', videoHoverEvent, false);
};
exports.default = videoHover;
